import { ColumnType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import reportApis from "../../../api/reports";
import dayjs from "dayjs";

interface MaterialSummaryReportProps {
  selectedDate: any;
  projectId: number;
}

const MaterialSummaryReport: React.FC<MaterialSummaryReportProps> = ({
  selectedDate,
  projectId,
}) => {
  const [dataSource, setDataSource] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });

  const columns: ColumnType<any>[] = [
    { title: "Material", dataIndex: "materialName", key: "materialName" },
    {
      title: "Issue QTY",
      dataIndex: "issuedQty",
      key: "issuedQty",
      render: (text: any, record: any) => (
        <span>
          {text} {record?.uom}
        </span>
      ),
    },
    {
      title: "Utilized QTY",
      dataIndex: "utilizedQty",
      key: "utilizedQty",
      render: (text: any, record: any) => (
        <span>
          {text} {record?.uom}
        </span>
      ),
    },
    {
      title: "Returned",
      dataIndex: "returnQty",
      key: "returnQty",
      render: (text: any, record: any) => (
        <span>
          {text} {record?.uom}
        </span>
      ),
    },
    {
      title: "Damaged",
      dataIndex: "damagedQty",
      key: "damagedQty",
      render: (text: any, record: any) => (
        <span>
          {text} {record?.uom}
        </span>
      ),
    },
  ];

  const fetchData = async (params: any) => {
    setLoading(true);
    try {
      const { current, pageSize, direction, pageDiff, paginationId } = params;

      const apiResponse = await reportApis.fetchPMSReports({
        projectIds: projectId,
        endDate: selectedDate && dayjs(selectedDate).format("YYYY-MM-DD"),
        reportName: "materialSumamryDailyProgress",
        sortOrder: "DESC",
        page: current,
        pageSize: pageSize,
      });

      const { data, status } = apiResponse || {};
      if (status) {
        const { list, count } = data;
        setPagination((prev) => ({
          ...prev,
          total: Number(count),
        }));
        if (list) setDataSource(list);
      }
    } catch (error) {
      console.error("Error loading material summary data:", error);
      message.error("Failed to load material summary data");
    } finally {
      setLoading(false);
    }
  };

  const tableOnChange = async (
    newPagination: any,
    filters: any,
    sorter: any
  ) => {
    const apiParams = {
      current: newPagination.current?.toString(),
      pageSize: pagination.pageSize,
      direction: "P",
      pageDiff: 0,
      paginationId: null,
    };

    if (newPagination.current !== pagination.current) {
      apiParams.direction =
        newPagination.current > pagination.current ? "F" : "B";
      apiParams.paginationId =
        apiParams.direction === "F"
          ? dataSource[dataSource.length - 1]?.paginationId
          : dataSource[0]?.paginationId;
      apiParams.pageDiff =
        Math.abs(newPagination.current - pagination.current) - 1;
    }

    setPagination({
      ...pagination,
      current: apiParams.current,
    });

    await fetchData(apiParams);
  };

  useEffect(() => {
    if (selectedDate) {
      fetchData({
        current: 1,
        pageSize: pagination.pageSize,
        direction: "P",
        pageDiff: 0,
        paginationId: null,
      });
    }
  }, [selectedDate]);

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={pagination}
      onChange={tableOnChange}
      loading={loading}
      size="small"
      bordered
    />
  );
};

export default MaterialSummaryReport;
